export const API_ROOT = process.env.VUE_APP_API_ROOT || 'https://sitebypro-server.ru/computerclub';

async function parseJson(response) {
  try {
    return await response.json();
  } catch (error) {
    return null;
  }
}

export function isSuccess(result) {
  return String(result?.status || '') === '200';
}

export function extractMessage(result, fallback = 'Ошибка запроса') {
  return result?.data?.text || result?.description || fallback;
}

export async function post(path, payload = {}, options = {}) {
  const response = await fetch(`${API_ROOT}${path}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
    body: JSON.stringify(payload),
  });

  return parseJson(response);
}

export async function postForm(path, formData, options = {}) {
  const response = await fetch(`${API_ROOT}${path}`, {
    method: 'POST',
    body: formData,
    ...options,
  });

  return parseJson(response);
}
